import { useMemo } from "react";
import getLocalMap, {
  LocalMapBuildType,
  LocalMapShow,
} from "tools/show/localMap/getLocalMap";
import useStableTranslate from "hooks/useStableTranslate";

const useLocalizedLocalMap = (
  show?: LocalMapShow,
  buildType?: LocalMapBuildType
) => {
  const { t, language } = useStableTranslate();

  return useMemo(() => getLocalMap(show, buildType, t), [
    show,
    buildType,
    language,
  ]);
};

export default useLocalizedLocalMap;
